import React from 'react';

export default function Footer() {
  return (
    <footer className="app-footer">
      <span className="app-footer-brand">🎬 Cinema Alert</span>
      <span className="app-footer-sep">·</span>
      <a href="/privacy-policy" className="app-footer-link">Privacy Policy</a>
      <span className="app-footer-sep">·</span>
      <a href="/terms" className="app-footer-link">Terms of Service</a>
      <span className="app-footer-sep">·</span>
      <a href="/contact" className="app-footer-link">Contact</a>
    </footer>
  );
}
